module.exports = __webpack_public_path__ + "static/AI_learning-6ede55fab0c3cc09fb4f3dbe06e3c4dd.png";